import moment from 'moment';

import { Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { BreadcrumbItem } from '@mitsubishi/shared/ui';
import { ApmDateUtils } from '@mitsubishi/utils';

import { ComponentStore } from '@ngrx/component-store';

export interface PriceListField {
  title: string;
  breadcrumb: BreadcrumbItem[];
  backlink: string[];
  organization:
    | {
        id: number;
        name: string;
      }
    | undefined;
  validityDate: string;
}

const defaultState: PriceListField = {
  title: '',
  breadcrumb: [],
  backlink: [],
  organization: undefined,
  validityDate: ApmDateUtils.toIsoDate(moment()),
};

@Injectable()
export class PriceListStore extends ComponentStore<PriceListField> {
  constructor() {
    super(defaultState);
  }

  /* Selectors */
  readonly title$ = this.select(({ title }) => title);
  readonly breadcrumb$ = this.select(({ breadcrumb }) => breadcrumb);
  readonly backlink$ = this.select(({ backlink }) => backlink);
  readonly organization$ = this.select(({ organization }) => organization);
  readonly validityDate$ = this.select(({ validityDate }) => validityDate);

  readonly organizationSignal = toSignal(this.select(({ organization }) => organization));

  /* Actions */
  readonly updatedBreadcrumb = this.updater((state: PriceListField, value: BreadcrumbItem[]) => {
    return {
      ...state,
      breadcrumb: value,
    };
  });
  readonly updatedBacklink = this.updater((state: PriceListField, value: string[]) => {
    return {
      ...state,
      backlink: value,
    };
  });
  readonly updatedTitle = this.updater((state: PriceListField, value: string) => {
    return {
      ...state,
      title: value,
    };
  });
  readonly updatedOrganization = this.updater(
    (
      state: PriceListField,
      value:
        | {
            id: number;
            name: string;
          }
        | undefined
    ) => {
      return {
        ...state,
        organization: value,
      };
    }
  );

  readonly updatedValidityDate = this.updater((state: PriceListField, value: moment.Moment) => ({
    ...state,
    validityDate: ApmDateUtils.toIsoDate(value),
  }));
}
